import { WorkspaceEngine } from "services/engines/engine.types";

import { Panel } from "../Panel";
import { EngineMenuActions } from "./EngineRow/EngineMenu";
import { ExpandedEngineRow } from "./EngineRow/ExpandedEngineRow";
import { ExpandedHeader } from "./ExpandedHeader";
import { OrderBy, OrderDirection } from "./types";

import styles from "./styles.module.scss";

export const ExpandedPanel = (props: {
  items: WorkspaceEngine[];
  pinnedItems?: WorkspaceEngine[];
  pinnedLabel?: string;
  pinnedEngineNames?: Set<string>;
  onTogglePin?: (engineName: string) => void;
  onChangeOrder: (order: { orderBy: OrderBy }) => void;
  order: {
    orderDirection: OrderDirection;
    orderBy: OrderBy;
  };
  actions: EngineMenuActions;
  testId?: string;
}) => {
  const {
    items,
    pinnedItems,
    pinnedLabel,
    pinnedEngineNames,
    onTogglePin,
    onChangeOrder,
    order,
    actions,
    testId,
  } = props;
  const showPinned = Boolean(pinnedItems?.length);
  const showSeparator = Boolean(showPinned && items.length);
  const renderRow = (engine: WorkspaceEngine) => {
    return (
      <ExpandedEngineRow
        key={engine.engineName}
        engine={engine}
        actions={actions}
        isPinned={pinnedEngineNames?.has(engine.engineName)}
        onTogglePin={onTogglePin}
      />
    );
  };
  return (
    <Panel testId={testId}>
      <ExpandedHeader
        onChangeOrder={onChangeOrder}
        order={order}
      />
      <div className={styles.enginesList}>
        {showPinned && pinnedLabel && (
          <div className={styles.pinnedHeader}>{pinnedLabel}</div>
        )}
        {showPinned && pinnedItems?.map(engine => renderRow(engine))}
        {showSeparator && <div className={styles.separator} />}
        {items.map(engine => renderRow(engine))}
      </div>
    </Panel>
  );
};
